(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('scroll', () => {
    const overlay = document.querySelector('.collection-overlay-title');

    if (!overlay) return;

    /* Fade based on viewport height instead of collection height */
    const fadeDistance = window.innerHeight * 0.18;

    const scrollY = window.scrollY;

    let opacity = 1 - scrollY / fadeDistance;

    opacity = Math.max(0, Math.min(1, opacity));

    overlay.style.opacity = opacity;

    /* Slight upward movement while fading */
    overlay.style.transform = `translateY(${scrollY * -0.08}px)`;

    /* Fully hide when faded */
    if (opacity <= 0.02) {
      overlay.style.visibility = 'hidden';
    } else {
      overlay.style.visibility = 'visible';
    }
  });

  } catch(e) { console.error(e); }
})();
})();
